"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M22,14.33a2,2,0,1,0-1.91-1.46l-3.52,2.06a2,2,0,0,0-3.35.9H9.65A2,2,0,1,0,5.83,16.9L1,20.05v-8l6.09-3.7A2,2,0,0,0,10.19,8L14.12,9.3a2,2,0,1,0,3.56-1.17l3.39-4.31a2,2,0,1,0-.75-.65L16.9,7.51a2,2,0,0,0-2.51.83L10.49,7.08a2,2,0,1,0-3.89.45L1,10.92V.86a.5.5,0,1,0-1,0V23.31a.5.5,0,0,0,.5.5H23a.5.5,0,0,0,0-1H1V21.25l5.31-3.49a2,2,0,0,0,3.31-.93h3.54a2,2,0,1,0,3.84-1l3.53-2.06A2,2,0,0,0,22,14.33Z"
  }));
};

exports["default"] = _default;